import { useEffect, useState } from 'react'
import axios from 'axios'
import { subMinutes } from 'date-fns'
import { SvgIconProps } from '@mui/material'
import { Aurora, AuroraAwhpData } from '../types'
import { getAuroraAwhpDataNow } from '../services/aurora'
import StatusIndicator from './StatusIndicator'

export interface AuroraStatusIndicatorProps extends SvgIconProps {
  aurora: Aurora
  auroraAwhpData?: AuroraAwhpData | null
}

export default function AuroraStatusIndicator({
  aurora,
  auroraAwhpData,
  ...props
}: AuroraStatusIndicatorProps) {
  const [status, setStatus] = useState<boolean>(
    auroraAwhpData === undefined || auroraAwhpData === null ? false : isOnline(auroraAwhpData)
  )

  useEffect(() => {
    if (auroraAwhpData === undefined) {
      const controller = new AbortController()

      loadStatus(aurora.id, controller)

      const ONE_MINUTE = 60 * 1000
      const interval = setInterval(() => loadStatus(aurora.id, controller), ONE_MINUTE)

      return () => {
        clearInterval(interval)
        controller.abort()
      }
    } else if (auroraAwhpData === null) {
      setStatus(false)
    } else {
      setStatus(isOnline(auroraAwhpData))
    }
  }, [aurora, auroraAwhpData])

  async function loadStatus(auroraId: string, controller: AbortController) {
    try {
      const data = await getAuroraAwhpDataNow(auroraId, { signal: controller.signal })
      setStatus(isOnline(data))
    } catch (error) {
      if (axios.isCancel(error)) {
        return
      }

      setStatus(false)
      console.error(error)
    }
  }

  function isOnline(auroraAwhpData: AuroraAwhpData) {
    return new Date(auroraAwhpData.time) > subMinutes(new Date(), 3)
  }

  return <StatusIndicator status={status} {...props} />
}
